import { useTranslation } from 'react-i18next';
import ActionsMenu from '../../../shared/components/NewTable/ActionMenu';
import { InviteSuppliers } from '../../Suppliers/InviteSuppliers';
import { BulkInviteSuppliers } from '../../Suppliers/BulkInviteSuppliers';
import { useToggle } from '@mantine/hooks';
import { useTracking } from '../../../hooks';

type AddSuppliersProps = {
  isModalOpen: boolean;
  toggleModal: () => void;
};

const AddSuppliers = ({ isModalOpen, toggleModal }: AddSuppliersProps) => {
  const { trackEvent } = useTracking();
  const { t } = useTranslation();
  const [isBulkInviteModalOpen, toggleBulkInviteModal] = useToggle();

  return (
    <>
      <ActionsMenu
        icon="plus"
        offset={10}
        position="right-start"
        buttonStyle={{ padding: 0 }}
        list={[
          {
            label: t('invite.suppliers.title'),
            onClick: () => {
              toggleModal();
              trackEvent('Supplier', {
                step: 'invite',
                action: 'open',
              });
            },
          },
          {
            label: t('invite.suppliers.csv'),
            onClick: () => {
              toggleBulkInviteModal();
              trackEvent('Supplier', {
                step: 'bulk-invite',
                action: 'open',
              });
            },
          },
        ]}
      />
      <InviteSuppliers isOpen={isModalOpen} toggleOpen={toggleModal} />
      <BulkInviteSuppliers
        isOpen={isBulkInviteModalOpen}
        toggleOpen={toggleBulkInviteModal}
      />
    </>
  );
};

export default AddSuppliers;
